import { useNotificationStore } from '@/stores/notification';
import { NotificationPanel } from './NotificationPanel';
import styles from './Topbar.module.css';

interface TopbarProps {
  title: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
}

export function Topbar({ title, ctaLabel, onCtaClick }: TopbarProps) {
  const { toggle, unreadCount } = useNotificationStore();

  return (
    <header className={styles.topbar}>
      <h1 className={styles.title}>{title}</h1>
      <div style={{ flex: 1 }} />
      <span className={styles.envBadge}>{import.meta.env.VITE_ENV_LABEL || 'PRODUCTION'}</span>
      <div className={styles.bellWrap}>
        <button className={styles.bellBtn} title="通知" onClick={(e) => { e.stopPropagation(); toggle(); }}>
          {'\uD83D\uDD14'}
          {unreadCount > 0 && <span className={styles.badge}>{unreadCount > 9 ? '9+' : unreadCount}</span>}
        </button>
        <NotificationPanel />
      </div>
      {ctaLabel && (
        <button className={styles.btn} onClick={onCtaClick}>{'\uFF0B'} {ctaLabel}</button>
      )}
    </header>
  );
}
